import { useState, useRef } from "react";
import "./editorialForms.css";

const categories = [
  { id: "technology", name: "Tecnologia" },
  { id: "lifestyle", name: "Estilo de Vida" },
  { id: "business", name: "Negócios" },
  { id: "travel", name: "Viagem" },
  { id: "food", name: "Gastronomia" },
  { id: "health", name: "Saúde" },
  { id: "finance", name: "Finanças" },
  { id: "entertainment", name: "Entretenimento" },
  { id: "education", name: "Educação" },
  { id: "personal", name: "Pessoal" },
];

export default function BlogForm({ data, onChange }) {
  const [tags, setTags] = useState(data?.tags?.join(", ") || "");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({ 
          ...data, 
          coverImage: file, 
          coverImageName: file.name,
          coverImagePreview: reader.result 
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTagsChange = (e) => {
    const value = e.target.value;
    setTags(value);
    const tagArray = value
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag.length > 0);
    onChange({ ...data, tags: tagArray });
  };

  return (
    <div className="editorial_form blog_form">
      <div className="editorial_form_section">
        <label>
          Imagem de Capa <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*,.jpg,.jpeg,.png,.webp"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.coverImagePreview ? (
            <div className="file_selected sticker_preview">
              <img src={data.coverImagePreview} alt="Capa" style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }} />
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, coverImage: null, coverImageName: null, coverImagePreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <p>Clique para fazer upload da capa</p>
              <span>JPG, PNG, WEBP</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Título do Artigo <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Título chamativo para seu artigo"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          maxLength={200}
        />
        <span className="editorial_form_counter">
          {(data?.title || "").length}/200
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Resumo / Excerpt</label>
        <textarea
          placeholder="Breve resumo do artigo (aparece na prévia)"
          value={data?.excerpt || ""}
          onChange={(e) => onChange({ ...data, excerpt: e.target.value })}
          rows={2}
          maxLength={500}
        />
        <span className="editorial_form_counter">
          {(data?.excerpt || "").length}/500
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione uma categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Tags</label>
        <input
          type="text"
          placeholder="react, javascript, frontend"
          value={tags}
          onChange={handleTagsChange}
        />
        <span className="editorial_form_hint">Separe as tags por vírgula</span>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isFeatured"
            checked={data?.isFeatured || false}
            onChange={(e) =>
              onChange({ ...data, isFeatured: e.target.checked })
            }
          />
          <label htmlFor="isFeatured">Artigo em destaque</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>
          Escreva o conteúdo completo no campo de texto principal. O tempo de leitura será calculado automaticamente.
        </span>
      </div>
    </div>
  );
}
